<template>
  <v-dialog
    v-model="confirmDialog"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    width="100%"
    max-width="500px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        color="primary"
        v-bind="attrs"
        v-on="on"
        small
        text
        style="padding: 5px"
      >
        <v-icon class="mr-2">mdi-history</v-icon>Change
      </v-btn>
    </template>
    <v-card style="padding: 25px; padding-bottom: 1px">
      <v-row style="margin-top: 0px">
        <v-col style="padding-top: 0px; padding-bottom: 0px">
          <v-dialog
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                outlined
                :value="computedDate"
                label="Date"
                prepend-inner-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date"
              @input="menu = false"
              :allowed-dates="allowedDates"
            ></v-date-picker>
          </v-dialog>
          <v-progress-linear
            v-if="tripsLoading || changeLoading"
            indeterminate
            color="primary"
          ></v-progress-linear>
        </v-col>
      </v-row>
      <div style="margin-bottom: 35px; margin-top: 18px">
        <v-row v-if="trips && trips.length === 0 && !tripsLoading">
          <div
            style="margin-left: 16px; margin-right: 16px; margin-bottom: 20px"
          >
            No trips available for this date.
          </div>
        </v-row>
        <v-row
          v-for="trip in trips"
          :key="trip.id"
          style="margin-left: 0px; margin-right: 0px; margin-bottom: 20px"
        >
          <v-card width="100%" elevation="0" outlined>
            <v-card-text>
              <v-row align="center">
                <v-col cols="7" align="center">
                  <!-- <div>
                    <v-icon class="mb-1">mdi-ferry</v-icon>
                    <span class="subtitle-1">{{ trip.boat.name }}</span>
                  </div>-->
                  <p
                    class="text-md-h4 text-lg-h4 text-xl-h4 text--primary text-h6"
                    style="margin: auto; padding: auto"
                  >
                    {{ toFromString(trip) }}
                  </p>
                  <div v-if="booking.isLocal">
                    {{ decimalCurrency(trip.laariPerSeatLocal) }} MVR or
                    {{ decimalCurrency(trip.centPerSeatLocal) }} USD / seat
                  </div>
                  <div v-else>
                    {{ decimalCurrency(trip.laariPerSeat) }} MVR or
                    {{ decimalCurrency(trip.centPerSeat) }} USD / seat
                  </div>
                </v-col>
                <v-col
                  v-if="trip.id === currentTrip.id"
                  cols="5"
                  align="center"
                >
                  <v-btn
                    text
                    color="primary"
                    style="padding-left: 3px; padding-right: 3px"
                    disabled
                    >Current</v-btn
                  >
                </v-col>
                <v-col v-else cols="5" align="center">
                  <div>{{ seatsLeft(trip) }}</div>
                  <v-btn
                    text
                    color="primary"
                    style="padding-left: 3px; padding-right: 3px"
                    :disabled="tripsLoading || changeLoading"
                    @click="changeBooking(trip)"
                    >Change</v-btn
                  >
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-row>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { toFromString } from "../helpers";

export default {
  name: "ChangeBooking",
  props: {
    booking: Object,
    isReturnTrip: Boolean,
    message: Function,
    errorMessage: Function,
    getBooking: Function,
    loading: Boolean,
  },
  data: () => ({
    confirmDialog: null,
    menu: null,
    date: null,
    currentTrip: null,
    trips: [],
    tripsLoading: false,
    changeLoading: false,
  }),
  computed: {
    computedDate() {
      return this.date ? moment(this.date).format("dddd, D MMMM YYYY") : "";
    },
  },
  methods: {
    allowedDates(date) {
      return moment(date, "YYYY-MM-DD").isSameOrAfter(moment(), "day");
    },
    toFromString(trip) {
      return toFromString(trip, this.$store.getters.getConfigs);
    },
    seatsLeft(trip) {
      const left = trip.capacity - trip.booked;
      return `${left} seat${left === 1 ? "" : "s"} left`;
    },
    decimalCurrency(number) {
      const small = number.toString();
      return (
        small.substring(0, small.length - 2) +
        "." +
        small.substring(small.length - 2)
      );
    },
    findRouteToStop(trip) {
      if (!trip || !trip.route) return;
      for (const stop of trip.route.stops) {
        if (stop.location.id !== this.currentTrip.fromLocation.id) continue;
        for (const toStop of stop.toStops) {
          if (toStop.location.id !== this.currentTrip.toLocation.id) continue;
          trip.routeToStop = toStop;
          trip.laariPerSeat = toStop.laariPerSeat;
          trip.laariPerSeatLocal = toStop.laariPerSeatLocal;
          trip.centPerSeat = toStop.centPerSeat;
          trip.centPerSeatLocal = toStop.centPerSeatLocal;
        }
      }
    },
    getTrips() {
      this.tripsLoading = true;
      const date = moment(this.date).toISOString();
      axios({
        url: `${
          process.env.VUE_APP_BASE_URL ?? ""
        }/api/getcustomertrips?date=${date}&from=${
          this.currentTrip.fromLocation.id
        }&to=${this.currentTrip.toLocation.id}`,
        method: "GET",
      })
        .then((resp) => {
          const trips = resp.data.trips ?? [];
          this.trips = trips;
          for (const trip of this.trips) {
            this.findRouteToStop(trip);
          }
        })
        .catch((error) => {
          if (error.response) {
            this.errorMessage(error.response.data.error);
          }
        })
        .finally(() => {
          this.tripsLoading = false;
        });
    },
    changeBooking(trip) {
      // if (this.booking.customers.length > trip.capacity - trip.booked) {
      //   this.errorMessage("Not enough seats available.");
      //   return;
      // }
      const data = {
        bookingUUID: this.booking.uuid,
        isReturnTrip: this.isReturnTrip,
        changeToTripId: trip.id,
      };
      this.changeLoading = true;
      axios({
        url: `${process.env.VUE_APP_BASE_URL ?? ""}/api/changebooking`,
        method: "POST",
        data,
      })
        .then((resp) => {
          this.message(resp.data.message);
          this.confirmDialog = false;
          this.getBooking();
        })
        .catch((error) => {
          if (error.response) {
            this.errorMessage(error.response.data.error);
          }
        })
        .finally(() => (this.changeLoading = false));
    },
  },
  watch: {
    confirmDialog: {
      handler: function () {
        if (this.confirmDialog) {
          this.currentTrip = this.isReturnTrip
            ? this.booking.returnTrip
            : this.booking.trip;
          this.date = moment(this.currentTrip.fromTime)
            .startOf("day")
            .format("YYYY-MM-DD");
        } else {
          this.getTrips();
        }
      },
    },
    date: {
      handler: function () {
        this.getTrips();
      },
    },
  },
};
</script>
